export default __webpack_public_path__ + "static/media/water-asset-icon.aa99194d.svg";